module.exports = __webpack_public_path__ + "img/download-file-hover.70599fb0.svg";